import React from 'react';
import PropTypes from 'prop-types';
import Tiles from './Tiles';
import TrayModule from '../TrayModule';
import Filters from './Filters';

const IconicStories = ({ className, sliceId }) => (
  <TrayModule className={className} sliceId={sliceId}>
    <Filters sliceId={sliceId} />
    <Tiles sliceId={sliceId} />
  </TrayModule>
);

IconicStories.propTypes = {
  className: PropTypes.string,
  sliceId: PropTypes.number.isRequired,
};

IconicStories.defaultProps = {
  className: undefined,
};

export default IconicStories;
